import { Navigate } from 'react-router'
import { useSettingsNavItems } from '@/constants/settingsNavItems'
import { firstLeafPath } from '@/utils/navTree'
import AccessDenied from '@/pages/AccessDenied'

/**
 * Resolves the bare `/admin` route to the user's first accessible Admin section
 * (C261373 — legacy redirected `/admin` → Website Settings). The nav tree from
 * `useSettingsNavItems()` is already filtered to the items the user can see, so the
 * Admin group's first child is the correct landing with no hardcoded destination.
 * Renders Access Denied when the user has no Admin access at all.
 */
export function AdminIndexRedirect() {
    const navItems = useSettingsNavItems()
    const adminGroup = navItems.find((item) => item.id === 'admin')
    const landing = adminGroup ? firstLeafPath(adminGroup) : undefined

    if (!landing) return <AccessDenied />
    return <Navigate to={landing} replace />
}
